import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';
import { FuseUpdateSubscriptionDialogComponent } from './update-subscription-dialog.component';

@NgModule({
    declarations: [
        FuseUpdateSubscriptionDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        CommonModule,
        TranslateModule,
    ]
})
export class FuseUpdateSubscriptionDialogModule {
}
